import React from 'react';
import { createRoot } from 'react-dom/client';
import { connect } from 'react-redux';

import readAttribute from 'common/tools/dom/readAttribute';
import { ReduxUser } from 'common/types';

import GraphFollowUnfollowUser from 'website/components/GraphFollowUnfollowUser';
import allocineContainer from 'website/containers/allocineContainer';

export default () => {
  const ConnectedFollowUnfollowButton = allocineContainer(
    connect((state: { user: ReduxUser }) => ({ user: state.user }))(
      GraphFollowUnfollowUser
    )
  );

  const followUnfollowUserButtonAnchors = document.getElementsByClassName(
    'js-follow-unfollow-user-button'
  );

  for (const followUnfollowUserButtonAnchor of followUnfollowUserButtonAnchors) {
    const followLegacyId = readAttribute<string, undefined>(
      followUnfollowUserButtonAnchor,
      'data-follow-legacy-id'
    );
    const followGraphId = readAttribute<string, undefined>(
      followUnfollowUserButtonAnchor,
      'data-follow-graph-id'
    );
    if (followLegacyId && followGraphId) {
      const buttonSize =
        readAttribute<string, undefined>(
          followUnfollowUserButtonAnchor,
          'data-button-size'
        ) || undefined;
      const buttonToRemove = followUnfollowUserButtonAnchor.querySelector(
        '.userprofile-hidden'
      );
      if (buttonToRemove) buttonToRemove.remove();
      const root = createRoot(followUnfollowUserButtonAnchor);
      root.render(
        <ConnectedFollowUnfollowButton
          followLegacyId={followLegacyId}
          followGraphId={followGraphId}
          buttonSize={buttonSize}
        />
      );
    }
  }
};
